var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankCustodianFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#00205A",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.8713V23.8713C12.5 24.7013 13.17 25.3713 14 25.3713C14.83 25.3713 15.5 24.7013 15.5 23.8713V19.8713C15.5 19.0413 14.83 18.3713 14 18.3713C13.17 18.3713 12.5 19.0413 12.5 19.8713ZM18.5 19.8713V23.8713C18.5 24.7013 19.17 25.3713 20 25.3713C20.83 25.3713 21.5 24.7013 21.5 23.8713V19.8713C21.5 19.0413 20.83 18.3713 20 18.3713C19.17 18.3713 18.5 19.0413 18.5 19.8713ZM12 30.3713H28C28.83 30.3713 29.5 29.7013 29.5 28.8713C29.5 28.0413 28.83 27.3713 28 27.3713H12C11.17 27.3713 10.5 28.0413 10.5 28.8713C10.5 29.7013 11.17 30.3713 12 30.3713ZM24.5 19.8713V23.8713C24.5 24.7013 25.17 25.3713 26 25.3713C26.83 25.3713 27.5 24.7013 27.5 23.8713V19.8713C27.5 19.0413 26.83 18.3713 26 18.3713C25.17 18.3713 24.5 19.0413 24.5 19.8713ZM19.07 9.86128L11.17 14.0213C10.76 14.2313 10.5 14.6613 10.5 15.1213C10.5 15.8113 11.06 16.3713 11.75 16.3713H28.26C28.94 16.3713 29.5 15.8113 29.5 15.1213C29.5 14.6613 29.24 14.2313 28.83 14.0213L20.93 9.86128C20.35 9.55128 19.65 9.55128 19.07 9.86128Z",
    fill: "#00205A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCustodianFilledIcon);
export default __webpack_public_path__ + "static/media/bank_custodian_filled_icon.35ff78f662159fda7ae7e9e03ab7e47d.svg";
export { ForwardRef as ReactComponent };